// extracted by mini-css-extract-plugin
export default {"btnPrimary":"BtnPrimary_btnPrimary__k5pY6","disabled":"BtnPrimary_disabled__04SQx"};